import src from "IMAGE";
export default { src, width: 252, height: 75, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABszRIUpSF+yCBAWMwYQGUcHERlEBxIaRgcSGkgHEBhFACZEVn05Y3yqCRIXJwYQFzcGEBYzBQ0TLAYRGDkECQ4hgjgKXhO9eUEAAAAASUVORK5CYII="};
